import { useMaskingContext } from "../Contexts/MaskingContext";

export default function useMaskPiiSetting(): [boolean, (value: boolean | ((prev: boolean) => boolean)) => void] {
  const { maskPii, setMaskPii } = useMaskingContext();
  return [maskPii, setMaskPii];
}
